import { action } from 'satcheljs';
import type { ActionSource } from 'owa-mail-store';

/**
 * Closes reading pane from command bar
 */
export interface CloseImmersiveReadingPaneActionMessage {
    source: ActionSource | undefined;
}
const defaultExport: (source?: ActionSource) => CloseImmersiveReadingPaneActionMessage = action(
    'closeImmersiveReadingPane',
    (source?: ActionSource): CloseImmersiveReadingPaneActionMessage => {
        return {
            source,
        };
    }
);
export default defaultExport;
